import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { isLoggedIn } from '../../Services/Auth';
import { logPageViews } from '../../Services/LoginService.js';
import Banner from '../../components/banner.js';
import Sidebar from '../../components/sidebar.js';
import { Row, Col, Container } from 'react-bootstrap';
import LandingPageBanner from '../LandingPageBanner.js';
import '../../styles/account.scss'
import { useMediaQuery, Alert, Divider, Button, TextField, Chip } from '@mui/material';
import { IconShoppingCartFilled,IconUserScan, IconCreditCard, IconUser, IconBuilding, IconBriefcase, IconMapPin, IconPhone, IconMail, IconLock, IconEye, IconEyeOff, IconLogin, IconChecks, IconArrowForward, IconArrowLeft, IconArrowRight } from '@tabler/icons-react';
import { useThemeManager } from '../../Context/ThemeManager.js';
const MyAccount = () => {
    const {theme} = useThemeManager();
    const [loggedIn, setLoggedIn] = useState(false);

    const country = localStorage.getItem("Activecountryversion");
    useEffect(() => {
        document.title = "Manage Account"
        setLoggedIn(isLoggedIn());
        logPage(); 
            async function logPage() {
                await logPageViews('Manage Account',"")
            }
        document.documentElement.style.setProperty('--primary-color', theme.primary);
        document.documentElement.style.setProperty('--titleGradient', theme.titleGradient);
        document.documentElement.style.setProperty('--buttonGradient', theme.buttonGradient);
        document.documentElement.style.setProperty('--bg', theme.bg);
    }, []);
    const fullName = localStorage.getItem('fullName') || 'Guest'; // Get full name of user
    const email = localStorage.getItem('email') || 'Guest'; // Get email of user
    const address = localStorage.getItem('address') || 'N/A'; // Get address of user
    const phoneNumber = localStorage.getItem('phoneNumber') || 'N/A'; // Get phone number of user
    const company = localStorage.getItem('company') || 'N/A'; // Get company of user
    const occupation = localStorage.getItem('occupation') || 'N/A'; // Get occupation of user
    
    // User Fields
    const userFields = [
      { id: 'email', label: 'Email', value: email, icon: <IconMail style={{ height: '16px', marginRight: '4px' }} /> },
      { id: 'phoneNumber', label: 'Phone Number', value: phoneNumber, icon: <IconPhone style={{ height: '16px', marginRight: '4px' }} /> },
      { id: 'companyName', label: 'Company Name', value: company, icon: <IconBuilding style={{ height: '16px', marginRight: '4px' }} /> },
      { id: 'occupation', label: 'Occupation', value: occupation, icon: <IconBriefcase style={{ height: '16px', marginRight: '4px' }} /> },
      { id: 'address', label: 'Address', value: address, icon: <IconMapPin style={{ height: '16px', marginRight: '4px' }} /> },
    ];

    const subscriptionType = localStorage.getItem('subscriptionType'); // Get full name of user
    const subscriptionEnd = localStorage.getItem('subscriptionEnd'); // Get full name of user
    const licenseCount = localStorage.getItem('licenseCount');
    
    
    const subscriptionStart = localStorage.getItem('subscriptionStart');
    const subscriptionStartDate = new Date(subscriptionStart);
    const startDate = subscriptionStartDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
    const subscriptionEndDate = new Date(subscriptionEnd);
    const endDate = subscriptionEndDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });

    // Get today's date
    const today = new Date();
    // Set the time components to zero to ensure accurate comparison
    today.setHours(0, 0, 0, 0);
    subscriptionEndDate.setHours(0, 0, 0, 0);

    // Calculate the difference in time (in milliseconds)
    const timeDifference = subscriptionEndDate - today;

    // Convert the time difference from milliseconds to days
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // 1 day = 1000ms * 60s * 60m * 24h

    // Determine if the remaining days are 30 or less
    const displayRemainingDays = daysDifference <= 30;

    // Check IMGateway
    const gateway = localStorage.getItem('gateway');
    const checkgateway = gateway !== 'false' && gateway !== undefined && gateway !== null && gateway !== '';
    const isLgScreen = useMediaQuery('(min-width:1024px)');
return (<>
          <Helmet>
              <meta name="viewport" content="width=device-width, initial-scale=1" />
          </Helmet>
          <Banner /> 
          <Sidebar />
          <div id="MyAccount">              
            <Container fluid id="main">
                <Row id="content">
                  <Col>
                      <div id="contentCaption">
                        <h2 style={{fontWeight: "bold"}}>Manage Account</h2>
                      </div>
                      <Row  className={ isLgScreen ? 'mt-4 ms-0 d-flex' : ''}>
                        <Col lg={8} xs={12} id="personalInformation" >
                          <div className='d-flex p-0' style={{color: theme.primary}}>
                              <IconUserScan style={{marginRight: 8}}/>
                              <h5 style={{ fontWeight: "bold", marginBottom: "12px", }}>
                                  Personal Information
                              </h5>
                          </div>
                          <hr className='mb-4 mt-1'/>
                          <Row>
                            <h4 style={{fontWeight: "bold", marginBottom: 16}}>{fullName}</h4>
                            {userFields.map((field) => (
                              <Col lg={field.id ==='address' ?  12:6}xs={12} className='details my-2'>
                                    <div className="label d-flex align-items-center mb-2">
                                      {field.icon} <span style={{fontWeight: "bold"}}>{field.label}</span>
                                    </div>
                                    <TextField
                                    id="filled-read-only-input"
                                    defaultValue={field.value}
                                    multiline
                                    maxRows={4}
                                    fullWidth
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                              </Col>
                              ))}
                          </Row>
                        </Col>
                        <Col lg={4} xs={12} id="subscriptionContainer" >
                        <div id="subscription">
                          <div className='d-flex p-0' style={{color: theme.primary}}>
                              <IconCreditCard style={{marginRight: 8}}/>
                              <h5 style={{ fontWeight: "bold", marginBottom: "12px", }}>
                                  Subscription
                              </h5>
                          </div>
                          <hr className='mb-4 mt-1'/>
                          <div className='d-flex flex-column mb-3'>
                                <strong>Subscription Type:</strong>
                                <Chip
                                  label={subscriptionType}
                                  variant="outlined"
                                  sx={{
                                    fontWeight: "bold",
                                    px: 2,
                                    mt: 1,
                                    border: "2px solid",
                                    borderColor: subscriptionType === "Full" ? theme.primary : "#ccc",
                                    color: subscriptionType === "Full" ? theme.primary : "#727272",
                                  }}
                                />
                          </div>
                          <div className='d-flex flex-column my-2'>
                                <div className='d-flex w-100 justify-content-between'>
                                  <div className= {isLgScreen ? 'd-flex flex-column col-lg-6' : 'd-flex flex-column w-100 col-lg-6'}>
                                        <strong>Start Date:</strong>
                                        <span>{startDate} </span>
                                  </div>
                                  <div className= {isLgScreen ? 'd-flex flex-column col-lg-6' : 'd-flex flex-column w-100 col-lg-6'}>
                                        <strong>End Date:</strong>
                                        <span>{endDate} </span>
                                  </div>
                                </div>
                                {displayRemainingDays && (
                                <Alert severity="error" sx={{mt:1}}>
                                  Your subscription will end in {daysDifference} days.
                                </Alert>
                                )}
                          </div>
                          <div className='d-flex flex-column my-2'>
                                <div className='d-flex w-100 justify-content-between'>
                                  <div className= {isLgScreen ? 'd-flex flex-column col-lg-6' : 'd-flex flex-column w-100 col-lg-6'}>
                                         <strong>License Count:</strong>
                                          <span>{licenseCount}</span>
                                  </div>
                                  <div className= {isLgScreen ? 'd-flex flex-column col-lg-6' : 'd-flex flex-column w-100 col-lg-6'}>
                                        <strong>IMGateway:</strong>
                                        {checkgateway ? (
                                        <span>Included</span>
                                        ):(
                                        <span style={{fontStyle: "italic", color: "#727272"}}>Not included</span>
                                        )}
                                  </div>
                                </div>
                          </div>
                          {subscriptionType === "Trial" || displayRemainingDays && (<>
                          <hr className='mb-3 mt-0' />
                          {/* <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            id="purchaseButton"
                            startIcon={<IconShoppingCartFilled />}
                            onClick={() => window.open('https://estore.mims.com.au', '_blank')}
                          >
                            Buy Subscription
                          </Button> 
                          <p style={{ marginTop: '20px', marginBottom: '8px', color: '#727272', fontSize: '12px', textAlign: 'center' }}>
                            You will be redirected to MIMS eStore to purchase your subscription. You may need to register for an eStore account to login.
                          </p>
                          */}
                          <Button className ="btn-disabled">Call MIMS Support at 1800 800 629 to purchase subscription.</Button>
                         </> )}
                        </div>
                        </Col>
                      </Row>
                  </Col>
                </Row>
            </Container>
          </div>
</>);
}
export default MyAccount;